import { CertifiedBaseIcon } from '@tableau/icons/CertifiedBaseIcon';
import { ButtonType, InteractionState } from '@tableau/widgets';
import React from 'react';
import { Messages } from '../../../../../../gen-src/Localize';
import { SvgCertifiedIconActive, SvgCertifiedIconDefault } from '../../../../../../gen-src/icons';
import { LabelPopover } from '../LabelPopover';
import { LabelRenderControlsWrapper } from '../shared/LabelRenderProps';
import { useControlledPopover, ButtonTriggerElementProps, ChipTriggerElementProps } from '../shared/useControlledPopover';
import { CertificationRenderProps } from './CertificationProps';

/**
 * NOTE:
 *
 * 1. if dehydrated, we're trusting the presence of category, content item to mean a render should happen
 * 2. if hydrated, we're trusting the presence of any labels in the label lists to mean a render should happen
 *
 * label calls useControlledPopover hook and renders the resulting popover
 * icon is a function used in `getContent` on iconProps
 * panel is a function used in content on useControlledPopover hook's params
 */
export type CertificationLabelProps = CertificationRenderProps & LabelRenderControlsWrapper;

export function CertificationLabel(props: CertificationLabelProps): JSX.Element {
  const popover = useControlledPopover<CertificationRenderProps>({
    testId: props.testId,
    popoverProps: {
      title: certificationLabelTitle(props),
      placement: props.controls?.popoverPlacement ?? 'bottom-start',
    },
    content: LabelPopover,
    controlKind: props.controls?.kind ?? 'icon',
    iconProps: certificationIconProps,
    chipProps: certificationChipProps,
    onClick: props.onClick,
    loading: props.loading,
    props: {
      ...props
    }
  });
  return popover ?? <></>;
}

function certificationIconProps(): ButtonTriggerElementProps {
  return {
    getContent: (s) => <CertificationIcon state={s} />,
    style: {
      height: '14px',
      width: '14px'
    },
    buttonType: ButtonType.Icon,
    kind: 'button-props',
  }
}

function CertificationIcon(props: { state?: InteractionState }): JSX.Element {
  const { state } = props;

  return (
    <span>
      {
        state?.active || state?.hover || state?.selected || false ?
          <SvgCertifiedIconActive /> :
          <SvgCertifiedIconDefault />
      }
    </span>
  )
}

function certificationChipProps(): ChipTriggerElementProps {
  return {
    stickerType: 'green',
    icon: <CertifiedBaseIcon size={12} alt={Messages.DataQualityTypeCertified()} />,
    kind: 'sticker-props',
  }
}

function certificationLabelTitle(_: CertificationLabelProps): string {
  return Messages.DataQualityTypeCertified();
}
